import { useState } from "react";
import { Trash2 } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { todayIso } from "./crmConst";

export const TaskList = ({ clientId, tasks, reload }) => {
  const [title, setTitle] = useState("");
  const [due, setDue] = useState(todayIso());
  const add = async () => {
    if (!title.trim() || !due) return;
    await api.post(`/crm/clients/${clientId}/tasks`, { title, due_date: due });
    setTitle(""); reload();
  };
  const toggle = async (t) => { await api.patch(`/crm/tasks/${t.id}`, { done: !t.done }); reload(); };
  const del = async (t) => { await api.delete(`/crm/tasks/${t.id}`); reload(); };
  const today = todayIso();
  return (
    <div className="space-y-3" data-testid="crm-tasks">
      <div className="flex gap-2">
        <Input placeholder="Relance, rappel, document à demander…" value={title} onChange={(e) => setTitle(e.target.value)} data-testid="crm-task-title" />
        <Input type="date" value={due} onChange={(e) => setDue(e.target.value)} className="w-40" data-testid="crm-task-due" />
        <Button className="bg-genis hover:bg-genis-dark text-white" onClick={add} disabled={!title.trim()} data-testid="crm-task-add">Ajouter</Button>
      </div>
      {tasks.map((t) => {
        const late = !t.done && t.due_date < today;
        return (
          <div key={t.id} className="flex items-center gap-3 rounded-lg border border-border px-3 py-2 group" data-testid={`crm-task-${t.id}`}>
            <Checkbox checked={t.done} onCheckedChange={() => toggle(t)} data-testid={`crm-task-check-${t.id}`} />
            <span className={`flex-1 text-sm ${t.done ? "line-through text-muted-foreground" : ""}`}>{t.title}</span>
            <span className={`text-xs ${late ? "text-red-600 font-semibold" : t.due_date === today && !t.done ? "text-amber-600 font-semibold" : "text-muted-foreground"}`}>
              {late ? "En retard · " : t.due_date === today && !t.done ? "Aujourd'hui · " : ""}{t.due_date.split("-").reverse().join("/")}
            </span>
            <button onClick={() => del(t)} className="opacity-0 group-hover:opacity-100 transition-opacity text-red-600" data-testid={`crm-task-del-${t.id}`}><Trash2 className="h-3.5 w-3.5" /></button>
          </div>
        );
      })}
      {!tasks.length && <p className="text-sm text-muted-foreground">Aucune tâche.</p>}
    </div>
  );
};
